import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    padding: $theme.sizing.scale700
}))

export const Card = styled('div', ({ $theme }) => ({
    padding: `4rem ${$theme.sizing.scale650}`,
    borderRadius: $theme.sizing.scale550,
    border: `1px solid ${$theme.colors.mono300}`,
    display: 'flex',
    gap: $theme.sizing.scale700,
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
}))

export const Title = styled('h1', ({ $theme }) => ({
    ...$theme.typography.HeadingSmall,
    margin: 0,
    textAlign: 'center',
    color: $theme.colors.warning300
}))

export const Subtitle = styled('h1', ({ $theme }) => ({
    ...$theme.typography.ParagraphMedium,
    margin: 0,
    textAlign: 'center'
}))

export const SpinnerContainer = styled('div', () => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
}))

export const Time = styled('p', ({ $theme }) => ({
    ...$theme.typography.ParagraphSmall,
    margin: 0,
    textAlign: 'center'
}))
